import React from 'react';
import { ArrowLeftRegular } from '@fluentui/react-icons';
import { WorkflowStep } from './useWorkflow';
import { useIntl } from 'react-intl';
import { Spinner } from '@fluentui/react';

interface StepHeaderProps {
  onBack: () => void;
  onNext: () => void;
  currentStep: WorkflowStep;
  canContinue: boolean;
  onStepClick: (step: WorkflowStep) => void;
  isLoading?: boolean;
}

const StepHeader: React.FC<StepHeaderProps> = ({
  onBack,
  onNext,
  currentStep,
  canContinue,
  onStepClick,
  isLoading,
}) => {
  const intl = useIntl();

  const renderStepBar = () => {
    const steps = [WorkflowStep.Step1, WorkflowStep.Step2, WorkflowStep.Step3];
    return (
      <div style={{ display: 'flex', alignItems: 'center', userSelect: 'none' }}>
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            <div
              onClick={() => onStepClick(step)}
              style={{
                width: '1.75rem',
                height: '1.75rem',
                borderRadius: '50%',
                background: currentStep >= step ? '#BFEFDC' : '#EEEEEE',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'black',
                fontWeight: 600,
                cursor: step < currentStep ? 'pointer' : 'default',
              }}
            >
              {index + 1}
            </div>
            {index < steps.length - 1 && (
              <div
                style={{
                  width: '2rem',
                  height: '2px',
                  background: currentStep > step ? '#BFEFDC' : '#EEEEEE',
                }}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    );
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative' }}>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '1rem' }}>
        <button
          onClick={onBack}
          style={{
            cursor: 'pointer',
            padding: '0.5rem 1rem',
            fontSize: '14px',
            borderRadius: '4px',
            color: '#242424',
            border: '1px solid #D1D1D1',
            background: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.25rem',
            height: '32px',
          }}
        >
          <ArrowLeftRegular style={{ marginTop: 'auto', marginBottom: 'auto' }} />
          Back
        </button>
        <div style={{ fontSize: '1.5rem', fontWeight: 600 }}>New Proposal</div>
      </div>
      <div style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>{renderStepBar()}</div>
      <button
        onClick={onNext}
        disabled={!canContinue}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          cursor: canContinue ? 'pointer' : 'not-allowed',
          background: canContinue ? '#0F6CBD' : '#E0E0E0',
          border: 'none',
          color: canContinue ? 'white' : '#A9A9A9',
          padding: '0.5rem 1rem',
          borderRadius: '4px',
        }}
      >
        {isLoading ? (
          <>
            <Spinner size={2} styles={{ root: { marginRight: 8 } }} />
            {intl.formatMessage({ id: 'step2.saving.message' })}
          </>
        ) : (
          'Next'
        )}
      </button>
    </div>
  );
};

export default StepHeader;
